// eslint-disable-next-line
import { NameSpacing } from '../../../NonReact/utils/NameSpacing'

export const CALLRECINTEGRATION_DETAILS = 'callRecIntegrationDetails'
export const SCOPE_ASSIGNMENTS = 'scopeAssignments'
export const COMMUNICATIONS_SETTINGS = 'communicationsSettings'
export const DUBBER_COMMUNICATIONS_SETTINGS = 'dubberCommunicationsSettings'
export const TEST_INTEGRATION = 'testIntegration'

export enum CallRecIntegrationDetails {
    GUID = 'guid',
    INTEGRATION_TYPE = 'integrationType',
    DESCRIPTION = 'description'
}

export enum ScopeAssignmentTabFieldNames {
    CME = 'cme',
    FILTER_RECURSIVELY = 'filterRecursively',
    TELEPHONY_SERVER = 'telephonyServer',
    PARTITION = 'partition'
}

export enum CommunicationsSettingsTabFieldNames {
    IPADDRESSONE = 'ipAddressOne',
    IPADDRESSTWO = 'ipAddressTwo',
    MAIN_AUTHENTICATION_DETAILS_USERNAME = 'mainAuthenticationDetailsUsername',
    MAIN_AUTHENTICATION_DETAILS_PASSWORD = 'mainAuthenticationDetailsPassword',
    SECONDARY_AUTHENTICATION_DETAILS_USERNAME = 'secondaryAuthenticationDetailsUsername',
    SECONDARY_AUTHENTICATION_DETAILS_PASSWORD = 'secondaryAuthenticationDetailsPassword',
    API_PARAMETERSONE = 'apiParametersOne',
    API_PARAMETERSTWO = 'apiParametersTwo'
}

export enum DubberCommunicationSettingsTabfieldNames {
    DUBBER_LOCATION_URLS = 'dubberLocationUrl',
    DEVELOPER_AUTH_USERNAME = 'developerAuthUsername',
    DEVELOPER_AUTH_PASSWORD = 'developerAuthPassword',
    ACCOUNT_AUTH_USERNAME = 'accountAuthUsername',
    ACCOUNT_AUTH_PASSWORD = 'accountAuthPassword',
    API_PARAMETERSONE = 'apiParametersOne',
    API_PARAMETERSTWO = 'apiParametersTwo'
}

export const CallRecIntegrationDetailsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(CALLRECINTEGRATION_DETAILS, fieldName)

export const ScopeAssignmentNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(SCOPE_ASSIGNMENTS, fieldName)

export const CommunicationsSettingsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(COMMUNICATIONS_SETTINGS, fieldName)

export const DubberCommunicationsSettingsNameSpacing: (fieldName: string) => string = (fieldName: string) =>
    NameSpacing(DUBBER_COMMUNICATIONS_SETTINGS, fieldName)

// General Tab
export const GUID_GENERAL_NAME: string = CallRecIntegrationDetailsNameSpacing(CallRecIntegrationDetails.GUID)
export const INTEGRATION_GENERAL_NAME: string = CallRecIntegrationDetailsNameSpacing(
    CallRecIntegrationDetails.INTEGRATION_TYPE
)
export const DESCRIPTION_GENERAL_NAME: string = CallRecIntegrationDetailsNameSpacing(
    CallRecIntegrationDetails.DESCRIPTION
)

// Scope Assignments Tab
export const CME_SCOPE_NAME: string = ScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.CME)
export const FILTER_RECURSIVELY_SCOPE_NAME: string = ScopeAssignmentNameSpacing(
    ScopeAssignmentTabFieldNames.FILTER_RECURSIVELY
)
export const TELEPHONY_SERVER_SCOPE_NAME: string = ScopeAssignmentNameSpacing(
    ScopeAssignmentTabFieldNames.TELEPHONY_SERVER
)
export const PARTITION_SCOPE_NAME: string = ScopeAssignmentNameSpacing(ScopeAssignmentTabFieldNames.PARTITION)

// API Communication Settings Tab

export const MAIN_IP_ADDRESS_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.IPADDRESSONE
)
export const SECONDARY_IP_ADDRESS_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.IPADDRESSTWO
)
export const MAIN_AUTHENTICATION_DETAILS_USERNAME_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.MAIN_AUTHENTICATION_DETAILS_USERNAME
)
export const MAIN_AUTHENTICATION_DETAILS_PASSWORD_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.MAIN_AUTHENTICATION_DETAILS_PASSWORD
)
export const SECONDARY_AUTHENTICATION_DETAILS_USERNAME_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.SECONDARY_AUTHENTICATION_DETAILS_USERNAME
)
export const SECONDARY_AUTHENTICATION_DETAILS_PASSWORD_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.SECONDARY_AUTHENTICATION_DETAILS_PASSWORD
)
export const API_PARAMETERS_ONE_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.API_PARAMETERSONE
)
export const API_PARAMETERS_TWO_NAME: string = CommunicationsSettingsNameSpacing(
    CommunicationsSettingsTabFieldNames.API_PARAMETERSTWO
)

// Dubber API Communication Settings Tab

export const DUBBER_LOCATION_URLS_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.DUBBER_LOCATION_URLS
)
export const MAIN_DEVELOPER_AUTHENTICATION_DETAILS_USERNAME_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.DEVELOPER_AUTH_USERNAME
)
export const MAIN_DEVELOPER_AUTHENTICATION_DETAILS_PASSWORD_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.DEVELOPER_AUTH_PASSWORD
)
export const ACCOUNT_AUTH_USERNAME_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.ACCOUNT_AUTH_USERNAME
)
export const ACCOUNT_AUTH_PASSWORD_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.ACCOUNT_AUTH_PASSWORD
)
export const DUBBER_API_PARAMETERS_ONE_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.API_PARAMETERSONE
)
export const DUBBER_API_PARAMETERS_TWO_NAME: string = DubberCommunicationsSettingsNameSpacing(
    DubberCommunicationSettingsTabfieldNames.API_PARAMETERSTWO
)
